module.exports = {
  siteTitle: 'Shahzar Ahmed | Software Engineer',
  siteDescription:
    'Shahzar Ahmed is a software engineer based in Dubai, U.A.E specializing in development & design of Android Mobile applications and Backend development.',
  siteKeywords:
    'Shahzar Ahmed, Shahzar, Ahmed, software engineer, mobile developer, android developer, javascript, dubai',
  siteUrl: 'https://shahzar.dev/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-156003442-1',
  googleVerification: '',
  name: 'Shahzar Ahmed',
  location: 'Dubai, UAE',
  email: 'shahzar@outlook.com',
  github: 'https://github.com/shahzar',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/shahzar',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/shahzar-ahmed',
    },
    {
      name: 'PlayStore',
      url: 'https://play.google.com/store/apps/developer?id=Shahzar+Ahmed',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Blog',
      url: '/blog/',
      external: true,
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,
  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
